import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    hiddenFileInput: {
        display: "none",
    },
    valueColumns: {
        flex: 1,
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        columnGap: theme.spacing(3),
        alignItems: "center",
    },
    columnLabel: {
        fontSize: theme.typography.caption.fontSize,
        textTransform: "uppercase",
        color: theme.palette.emteria.text.secondary,
    },
    valueText: {
        display: "inline-block",
        width: "100%",
    },
    changedValue: {
        color: theme.palette.emteria.error,
        fontWeight: theme.typography.fontWeightMedium,
    },
    valueHeaderRow: {
        marginBottom: theme.spacing(1),
    },
    buttonsRow: {
        display: "flex",
        gap: theme.spacing(2),
        marginTop: theme.spacing(3),
        flexWrap: "wrap",
        width: "100%",
        alignItems: "center",
    },
    buttonSpacer: {
        flexGrow: 1,
        minWidth: theme.spacing(2),
    },
    streamingContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: theme.spacing(2),
    },
    collapsibleWrapper: {
        flex: 1,
        minWidth: 0,
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    menuWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        position: "absolute",
        right: 0,
    },
    loaderContainer: {
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        backgroundColor: theme.palette.emteria.background.paperDeep,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        justifyContent: "flex-end",
        zIndex: 1000,
    },
}));
